/******** Swiper ********/
class CodiSwiper {
    constructor(element, additionalSwiper) {
      var options =
        arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.element = element;
      this.thumb = additionalSwiper;
      this.initialConfig = JSON.parse(
        element.getAttribute("data-swiper-settings")
      );
  
      if (additionalSwiper) {
        this.initialConfigThumbs = JSON.parse(
          additionalSwiper.getAttribute("data-swiper-thumb-settings")
        );
      }
      this.options = options;
      this.build();
    }
  
    selectCell(index) {
      this.swiperElement.slideTo(index);
    }
  
    resize() {
      this.swiperElement.resize();
    }
  
    build() {
      var _this = this,
        configThumb = this.initialConfigThumbs;
        
      if (configThumb != null) {
        this.thumbSwiper = new Swiper(this.thumb, configThumb);
        this.initialConfig.thumbs["swiper"] = this.thumbSwiper;
      }
  
      this.swiperElement = new Swiper(this.element, this.initialConfig);
      this.selectedIndex = this.swiperElement.activeIndex;
  
      this.swiperElement.on("slideChange", function () {
  
        _this.element.dispatchEvent(
          new CustomEvent("swiper:slide-changed", {
            bubbles: true,
            detail: {
              currentIndex: _this.swiperElement.activeIndex,
              element: _this.swiperElement.el[0],
            },
          })
        );
      });
  
  
    }
}
/******** Swiper ********/

/******** Banner ********/
class mainBanner extends HTMLElement {
    constructor() {
        super();
        this.element = this;
        this.carouselElement = this.element.querySelector(".swiper");
        this.carousel = new CodiSwiper(this.carouselElement);
    }
}
customElements.define("main-banner", mainBanner);
/******** Banner ********/

/****** Product page ******/
class ProductElement extends HTMLElement {
  constructor() {
      super();
      this.element = this;
      this.carouselElement = this.element.querySelector(".mainSwiper");
      this.carouselElementThumbs = this.element.querySelector(
        ".thumbnailsSwiper"
      );
      this.carousel = new CodiSwiper(
        this.carouselElement,
        this.carouselElementThumbs
      );
      
  }
}
customElements.define("product-element", ProductElement);
/****** Product page ******/

/****** Swiper section ******/
class NewSwiper extends HTMLElement {
  constructor() {
      super();
      this.element = this;
      this.carouselElement = this.element.querySelector(".swiper");
      this.carousel = new CodiSwiper(this.carouselElement);
  }
}
customElements.define("swiper-section", NewSwiper);
/****** Swiper section ******/